import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { ModelViewSetting } from '../setting/ModelViewCodeSettting';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class ModelViewSceneBlock extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.MODEL_VIEW, t.to('シーンスタート', 'scene_start'));
    this.setNameForCode('model-viewer');
    this.setLibraryWithAtt(
      `type="module" defer`,
      'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js'
    ).setLibraryWithAtt(
      `nomodule  defer`,
      'https://unpkg.com/@google/model-viewer/dist/model-viewer-legacy.js'
    );
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setSceneColor(block);
    ShapeSettings.setSceneStartShape(block);
    ShapeSettings.setTitleField(block, t.to('ARモデルビュワーβ', 'model_viewer'));

    const classField = new Blockly.FieldTextInput('model');
    ShapeSettings.setTitleField(block, 'css class');
    block.appendDummyInput().appendField(classField, 'cssClass');

    const altField = new Blockly.FieldTextInput('model');
    ShapeSettings.setTitleField(block, 'alt');
    block.appendDummyInput().appendField(altField, 'alt');

    const arModes = new Blockly.FieldTextInput('webxr scene-viewer quick-look');
    ShapeSettings.setTitleField(block, 'ar-modes');
    block.appendDummyInput().appendField(arModes, 'ar-modes');

    const arScale = new Blockly.FieldTextInput('auto');
    ShapeSettings.setTitleField(block, 'ar-scale');
    block.appendDummyInput().appendField(arScale, 'ar-scale');

    const src = new Blockly.FieldTextInput('/assets/429/uploaded/devaking.glb');
    ShapeSettings.setTitleField(block, 'src');
    block.appendDummyInput().appendField(src, 'src');

    const iosSrc = new Blockly.FieldTextInput('/assets/429/uploaded/devaking.glb');
    ShapeSettings.setTitleField(block, 'ios-src');
    block.appendDummyInput().appendField(iosSrc, 'ios-src');

    const poster = new Blockly.FieldTextInput('/assets/429/uploaded/image.png');
    ShapeSettings.setTitleField(block, 'poster');
    block.appendDummyInput().appendField(poster, 'poster');

    const backgroundColor = new Blockly.FieldTextInput('/assets/429/uploaded/image.png');
    ShapeSettings.setTitleField(block, 'background-color');
    block.appendDummyInput().appendField(backgroundColor, 'background-color');

    const shadowIntensity = new Blockly.FieldTextInput('0.7');
    ShapeSettings.setTitleField(block, 'shadow-intensity');
    block.appendDummyInput().appendField(shadowIntensity, 'shadow-intensity');

    const interactionPrompt = new Blockly.FieldTextInput('0.7');
    ShapeSettings.setTitleField(block, 'interaction-prompt');
    block.appendDummyInput().appendField(interactionPrompt, 'interaction-prompt');

    const skyboxImage = new Blockly.FieldTextInput('/assets/429/uploaded/skybox.jpg');
    ShapeSettings.setTitleField(block, 'skybox-image');
    block.appendDummyInput().appendField(skyboxImage, 'skybox-image');
  }
  generateStaticHTMLCode(): string {
    const code = `
<style>
html, body {
  width: 100%;
  height: 100%;
}

model-viewer.model {
  width: 100%;
  height: 100%;
  --poster-color: transparent;
}

/* http://meyerweb.com/eric/tools/css/reset/
v2.0 | 20110126
License: none (public domain)
 */
 
 html, body, div, span, applet, object, iframe,
 h1, h2, h3, h4, h5, h6, p, blockquote, pre,
 a, abbr, acronym, address, big, cite, code,
 del, dfn, em, img, ins, kbd, q, s, samp,
 small, strike, strong, sub, sup, tt, var,
 b, u, i, center,
 dl, dt, dd, ol, ul, li,
 fieldset, form, label, legend,
 table, caption, tbody, tfoot, thead, tr, th, td,
 article, aside, canvas, details, embed,
 figure, figcaption, footer, header, hgroup,
 menu, nav, output, ruby, section, summary,
 time, mark, audio, video {
   margin: 0;
   padding: 0;
   border: 0;
   font-size: 100%;
   font: inherit;
   vertical-align: baseline;
 }
 /* HTML5 display-role reset for older browsers */
 article, aside, details, figcaption, figure,
 footer, header, hgroup, menu, nav, section {
   display: block;
 }
 body {
   line-height: 1;
 }
 ol, ul {
   list-style: none;
 }
 blockquote, q {
   quotes: none;
 }
 blockquote:before, blockquote:after,
 q:before, q:after {
   content: '';
   content: none;
 }
 table {
   border-collapse: collapse;
   border-spacing: 0;
 }
 </style>
    `;

    return code;
  }

  codeGenerateCore(block: BlockType): string {
    const classField = CodeSetting.getFieldValue(block, 'cssClass');
    const classAtt = CodeSetting.getAttributeCode('class', `${classField}`);

    const altField = CodeSetting.getFieldValue(block, 'alt');
    const altAtt = CodeSetting.getAttributeCode('alt', `${altField}`);

    const arModes = CodeSetting.getFieldValue(block, 'ar-modes');
    const arModesAtt = CodeSetting.getAttributeCode('ar-modes', `${arModes}`);

    const arScale = CodeSetting.getFieldValue(block, 'ar-scale');
    const arScaleAtt = CodeSetting.getAttributeCode('ar-scale', `${arScale}`);

    const src = CodeSetting.getFieldValue(block, 'src');
    const srcAtt = CodeSetting.getAttributeCode('src', `${src}`);

    const iosSrc = CodeSetting.getFieldValue(block, 'ios-src');
    const iosSrcAtt = CodeSetting.getAttributeCode('ios-src', `${iosSrc}`);

    const poster = CodeSetting.getFieldValue(block, 'poster');
    const posterAtt = CodeSetting.getAttributeCode('poster', `${poster}`);

    const backgroundColor = CodeSetting.getFieldValue(block, 'background-color');
    const backgroundColorAtt = CodeSetting.getAttributeCode(
      'background-color',
      `${backgroundColor}`
    );

    const shadowIntensity = CodeSetting.getFieldValue(block, 'shadow-intensity');
    const shadowIntensityAtt = CodeSetting.getAttributeCode(
      'shadow-intensity',
      `${shadowIntensity}`
    );

    const interactionPrompt = CodeSetting.getFieldValue(block, 'interaction-prompt');
    const interactionPromptAtt = CodeSetting.getAttributeCode(
      'interaction-prompt',
      `${interactionPrompt}`
    );

    const skyboxImage = CodeSetting.getFieldValue(block, 'skybox-image');
    const skyboxImageAtt = CodeSetting.getAttributeCode('skybox-image', `${skyboxImage}`);

    const arAtt = CodeSetting.getAttributeCode('ar', ``);
    const autoRotateAtt = CodeSetting.getAttributeCode('auto-rotate', ``);
    const cameraControlsAtt = CodeSetting.getAttributeCode('camera-controls', ``);

    const str = ModelViewSetting.getModelViewCode(
      this.name_for_code,
      this.libs,
      `${cameraControlsAtt}
       ${arAtt}
       ${autoRotateAtt}
       ${skyboxImageAtt}
       ${interactionPromptAtt}
       ${cameraControlsAtt}
       ${shadowIntensityAtt}
       ${backgroundColorAtt}
       ${posterAtt}
       ${iosSrcAtt}
       ${srcAtt}
       ${arScaleAtt}
       ${arModesAtt}
       ${altAtt}
       ${classAtt}`,
      '',
      'floor'
    );
    return str;
  }
}
